import { Drawer } from "antd";
import { createGlobalStyle } from "styled-components";
import { PortalHeader } from "../../../../../../components/molecules/Header";
import { portalDrawerAntHeaderCss } from "../../../../../../components/molecules/Header/Header.styles";

const FilesDrawerTheme = createGlobalStyle`
  .files-upload-drawer .ant-drawer-content {
    background: #fff;
    border-left: 1px solid var(--PEARL, #ecf1f4);
    color: var(--GREY, #4a4a68);
    font-family: Inter, sans-serif;
  }
  .files-upload-drawer .ant-drawer-header {
    ${portalDrawerAntHeaderCss}
  }
  .files-upload-drawer .ant-drawer-title {
    font-family: inherit;
    width: 100%;
  }
  .files-upload-drawer .ant-drawer-body {
    display: flex;
    flex-direction: column;
    padding: 0;
    overflow: hidden;
  }

  .files-upload-drawer .fileManagerSelect .selectDropDown,
  .files-upload-drawer .fileManagerSelect .selectElement {
    width: 100%;
  }

  .files-upload-drawer .fileManagerSelect .labelForInput {
    margin-bottom: 4px;
    color: #4a4a68;
    font-size: 12px;
    font-weight: 600;
    line-height: 18px;
  }

  .files-upload-drawer .fileManagerSelect .inputValuePlace {
    height: 36px;
    border-radius: 6px;
    border-color: #d5deea;
    background-color: #fff;
    color: #8b93a7;
    padding-right: 28px;
  }

  .files-upload-drawer .fileManagerSelect .inputValuePlace.hasValue {
    color: #10244d;
  }

  .files-upload-drawer .fileManagerSelect .inputValuePlace.focusInput {
    border-color: #2060ea;
    box-shadow: 0 0 0 3px rgba(32, 96, 234, 0.12);
  }

  .files-upload-drawer .fileManagerSelect .optionsOfSelect {
    top: calc(100% + 4px);
    left: 0;
    z-index: 30;
    padding: 6px;
    border: 1px solid #e5eaf0;
    border-radius: 8px;
    box-shadow: 0 10px 28px rgba(16, 36, 77, 0.12);
  }

  .files-upload-drawer .fileManagerSelect .optionItem {
    border-radius: 6px;
    padding: 8px 10px;
  }

  .files-upload-drawer .fileDrawerFooter {
    border-top: 1px solid #ecf1f4;
    gap: 8px;
    padding: 12px 16px;
  }

  .files-upload-drawer .fileDrawerFooter button {
    height: 34px;
    padding: 0 16px;
    border: 1px solid #d5deea;
    border-radius: 6px;
    font-size: 13px;
    font-weight: 600;
    line-height: 20px;
    transition:
      background-color 0.15s ease,
      border-color 0.15s ease,
      color 0.15s ease;
  }

  .files-upload-drawer .fileDrawerFooter button:first-child {
    background: #2060ea;
    border-color: #2060ea;
    color: #fff;
  }

  .files-upload-drawer .fileDrawerFooter button:first-child:hover:not(:disabled) {
    background: #1249bf;
    border-color: #1249bf;
    color: #fff;
  }

  .files-upload-drawer .fileDrawerFooter button:last-child {
    background: #fff;
    border-color: #d5deea;
    color: #1249bf;
  }

  .files-upload-drawer .fileDrawerFooter button:last-child:hover:not(:disabled) {
    background: #f4f7ff;
    border-color: #2060ea;
    color: #1249bf;
  }

  .files-upload-drawer .fileDrawerFooter button:disabled:not([aria-busy="true"]) {
    background: #f7f8f9;
    border-color: #e5eaf0;
    color: rgba(0, 0, 0, 0.25);
  }
`;

export function FilesDrawer({ isOpen, title, supplementary, onClose, children }) {
  return (
    <>
      <FilesDrawerTheme />
      <Drawer
        open={isOpen}
        title={<PortalHeader title={title} supplementary={supplementary} onClose={onClose} />}
        rootClassName="files-upload-drawer"
        placement="right"
        width="min(1240px, calc(100vw - 32px))"
        styles={{
          header: { padding: 0 },
          body: { padding: 0, overflow: "hidden" },
          mask: { backgroundColor: "rgba(0, 0, 0, 0.3)", backdropFilter: "blur(1px)" },
        }}
        onClose={onClose}
        closable={false}
        maskClosable={false}
        keyboard
        destroyOnClose
      >
        {children}
      </Drawer>
    </>
  );
}
